import { Box, Typography } from '@mui/material';
import { styled } from '@mui/styles';

export const BlurredBackground = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: theme.palette.text.primary,
  opacity: 0.95,
  borderRadius: '20px',
  zIndex: 1
}));

export const OverlayContent = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  zIndex: 2,
  padding: theme.spacing(3),
  color: 'white'
}));

export const OverlayContentTitle = styled(Typography)(() => ({
  fontWeight: 600,
  marginBottom: '0.5rem',
  color: 'inherit'
}));
